import React from 'react'

import { useControllableState } from '@radix-ui/react-use-controllable-state'

import * as Parts from './Dropdown.parts'
import { DropdownContextProvider } from './DropdownContextProvider'

type SubProps = Omit<React.ComponentPropsWithoutRef<typeof Parts.Root>, 'asChild'> & {}

export const DropdownSub: React.FC<SubProps> = ({ open, defaultOpen, onOpenChange, ...props }) => {
    const [isOpen = false, setIsOpen] = useControllableState({
        prop: open,
        onChange: onOpenChange,
        defaultProp: defaultOpen,
    })

    return (
        <DropdownContextProvider isOpen={isOpen} setIsOpen={setIsOpen}>
            <Parts.Sub open={isOpen} onOpenChange={setIsOpen} {...props} />
        </DropdownContextProvider>
    )
}
